export default __webpack_public_path__ + "static/Pc_lightning_rgb-eb965a3f2ee80e0911b9674a82e3759b.png";